// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fetcher = async (url: string, params?: Record<string, any>, method = 'GET'): Promise<any> => {
  const queryString = params ? '?' + new URLSearchParams(params).toString() : ''

  const response = await fetch(`${url}${queryString}`, {
    method,
    headers: ({
      'Content-Type': 'application/json'
    })
  })

  if (!response.ok) {
    throw new Error(`Fetch error: ${response.statusText}`)
  }

  return response.json()
}

export default fetcher
